import { ref, watch } from 'vue'
import { useFrontEndDataQuery } from '../queries/useFrontEndDataQuery'
import { DropdownOption } from '@/api/contracts/models'

export function useCoreWebVitalsMetrics() {
   const { data: frontendData } = useFrontEndDataQuery()
   const result = ref<undefined | DropdownOption[]>(undefined)

   const setMetrics = () => {
      result.value = frontendData.value!.coreWebVitalMetrics
   }

   watch(
      [frontendData],
      () => {
         if (frontendData.value) {
            setMetrics()
         }
      },
      { immediate: true, deep: true }
   )

   return result
}
